export default __webpack_public_path__ + "static/media/pdf.a5cdd0d1.png";